import React from 'react'
import { connect } from "react-redux";
import { APP_URL } from '../../constants';
import withAuth from '../../hocs/withAuth';
import { verifyGateWayUser } from "../../store/actions/auth";
import { showLoader, hideLoader } from '../../store/actions/loader';
class PayPalConnection extends React.Component {

  componentDidMount() {
    const { showLoader } = this.props;
    const queryParams = new URLSearchParams(this.props.location.search);
    const code = queryParams.get('code');
    const next = queryParams.get('next');
    if (code) {
      showLoader();
      this.props.verifyGateWayUser(code).then(() => {
          this.moveToNextPage(next);
      }).catch(() => {
          this.moveToNextPage(next);
      });
    } else {
      this.moveToNextPage(next);
    }
  }

  moveToNextPage(param) {
    setTimeout(() => {
      this.props.hideLoader();
      if (param === 'settings') {
        window.location.href = APP_URL + '/settings/billing';
      } else {
        if (param === 'share') {
          window.location.href = APP_URL + '/share';
        } else {
          window.location.href = APP_URL + '/build/workout';
        }
      }
    }, 10000);
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="content-box video-popup">
            <div className="col-md-10 col-md-offset-1">
              <div className="content">
                <h1>Please do not refresh this page or close this web browser while we are connecting your Stripe account. We want you to get PAID! This could take a few minutes so please sit back and hang tight for a moment <span role="img" aria-label="content">&#128522;</span></h1>
                <img src={"/assets/img/logo.png"} alt="Fitbanx_logo" style={{ display: "block", marginLeft: "auto", marginRight: "auto", width: "50%" }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.currentUser.user,
    payments: []
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    verifyGateWayUser: (code) => {
      return dispatch(verifyGateWayUser(code));
    },
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader())
  }
}

export default withAuth(connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(PayPalConnection));



// WEBPACK FOOTER //
// ./src/components/settings/PaypalConnection.js